import React from 'react';
import { Box } from '@common-fe/common-fe';

import { BankingBalancePlanDetail } from '@/modules/employer/components/BankingBalance/types';

import BankingBalancePlanCard from './BankingBalancePlanCard';

interface Props {
  plans?: BankingBalancePlanDetail[];
  orgId?: string;
}

const BankingBalancePlanDetails: React.FC<Props> = ({ plans, orgId }) => {
  if (!plans?.length) return null;

  return (
    <Box data-testid="banking-balance-plan-details" gap="spacing24">
      {plans.map((plan, i) => (
        <BankingBalancePlanCard key={plan.planId} plan={plan} orgId={orgId} isFirst={i === 0}/>
      ))}
    </Box>
  );
};

export default BankingBalancePlanDetails;
